import {FormControl} from "@angular/forms";

export function validateEmail(ctrl:FormControl){

  const emailValue = ctrl.value;

  //const valid = /^((https?):\/\/)?([w|W]{3}\.)+[a-zA-Z0-9\-\.]{3,}\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/.test(urlValue);
  const valid = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i.test(emailValue);


  return valid ? null:{
      validEmail:{
        valid:false
      }

    }
}



// WEBPACK FOOTER //
// ./src/app/shared/validators/validate-email.ts